import React from 'react';
import { ClassAssembly11A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly11A2026/>;
  };
  
  export default ClassAssemblyPage;